// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-UbAbrm","img":"img-SKlZph","tips":"tips-EkbRTA","btn":"btn-Fd6YlG","logisticBtn":"logisticBtn-szZr0O","text":"text-MEztZw","noDataEmpty":"noDataEmpty-QFG5v2"};